<div class="p-relative">
  <ng-select
    [items]="items"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [multiple]="multiple"
    [loading]="isLoading"
    [typeahead]="searchTerm$"
    [placeholder]="placeholder"
    [ariaLabel]="placeholder"
    [clearable]="clearable"
    [virtualScroll]="true"
    [searchable]="true"
    [(ngModel)]="value"
    (change)="onValueChange($event)"
    (search)="onSearch($event)"
    class="custom-ng-select-autocomplete"
  >
      <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
        <span [innerHTML]="item[bindLabel] | highlight: search"></span>
      </ng-template>
      <ng-template ng-loading-text>
        <mat-spinner diameter="20"></mat-spinner> Loading...
      </ng-template>
  </ng-select>

  <div class="p-pos-icon">
    <i class="sd sd-search-refraction icon-20"></i>
  </div>
</div>

  <!-- <ng-template ng-option-tmp let-item="item">
    {{ item[bindLabel] }}
  </ng-template> -->